<script>
    import {createEventDispatcher} from 'svelte/internal';

    export let label = null;
    export let value = null;
    export let title = '';
    export let checked = 0;
    export let disabled = false;
    export let editable = true;
    export let css_class = '';

    const dispatch = createEventDispatcher();

    const onClick = () => {
        if (!disabled && editable) {
            checked = !checked;
            dispatch('click', { name, value, checked });
        }
    }

    $: checked = ~~checked;
</script>

<div class="checkbox-control { css_class }" class:disabled="{ disabled }" title="{ title }" on:click|stopPropagation="{ onClick }">
    <div class="icon">
        {#if checked }
            <i class="fa fa-check"></i>
        {/if}
    </div>
    {#if label !== null}
        <div class="label">{ label }</div>
    {/if}
</div>

<style>
    .checkbox-control {
        margin-top: 10px;
        margin-bottom: 10px;
        cursor: pointer;
    }
    .checkbox-control:after{
        content:"";
        clear:both;
        display:table
    }
    .checkbox-control .icon {
        position: relative;
        float: left;
        width: 1em;
        height: 1em;
        color: #455a64;
        border: 1px solid #ccc;
        border-radius: 2px;
        margin: 2px 0;
    }
    .checkbox-control .icon i {
        position: absolute;
        top: -1px;
        left: 1px;
        /* transform: translate(-50%, -50%);*/
    }
    .checkbox-control .label {
        width: calc(100% - 30px);
        float: left;
        font-size: 14px;
        padding-left: 5px;
    }
    .checkbox-control.disabled, .checkbox-control.disabled .icon {
        color: #888;
        cursor: not-allowed;
    }

    .inline-checkbox {
        display: inline-block;
        white-space: nowrap;
    }
    .inline-checkbox + .inline-checkbox {
        margin-top: 0;
        margin-left: 10px;
    }
</style>